import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { isNullOrEmptyString } from '../../../../shared/utils.js';
import { isNullOrUndefined } from 'util';

import { CLPUser, OfficeCodes, TeamCodes } from '../../../models/clpuser.model';
import { CompanyResponse } from '../../../models/company.model';
import { eMailingCategory, eUserPermissions, eUserRole } from '../../../models/enum.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { LCCheckedInRequest, LiveConnectSettingResponse, LiveConnectt, EmailBoxResponse, EmailBox, eEmailBoxStatus, eEmailBoxProcessor } from '../../../models/live-connect.model';
import { VoiceRecording } from '../../../models/voiceRecordings.models';
import { AppConfig } from '../../../models/appConfig.model';
import { CustomSearchResponse } from '../../../models/report.model';
import { SearchItemListResponse, keyValue } from '../../../models/search.model';
import { NotificationService } from '../../../services/notification.service';

import { AccountSetupService } from '../../../services/accountSetup.service';
import { LiveConnectService } from '../../../services/live-connect.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { GlobalService } from '../../../services/global.service';
import { AppconfigService } from '../../../services/shared/appconfig.service';
import { SearchContactService } from '../../../services/Searchcontact.service';
import { ReportService } from '../../../services/report.service';
import { LocalService } from '../../../services/shared/local.service';

@Component({
    selector: 'lc-setting-form',
    templateUrl: './lc-setting-form.component.html',
    styleUrls: ['./lc-setting-form.component.css']
})
/** lc-setting-form component*/
export class LcSettingFormComponent {
    /** lc-setting-form ctor */
    isShowSettings: boolean = false;
    liveSettingForm: FormGroup;
    @Input() user: CLPUser;
    @Input() isFromLiveConnect: boolean = false;
    isShowViewMode: boolean = true;
    encryptedUser: string = "";
    liveConnectId: number = 0;
    officeCodes: OfficeCodes[];
    teamCodes: TeamCodes[];
    officeCodesSRS: OfficeCodes[];
    teamCodesSRS: TeamCodes[];
    voiceRecordDD: VoiceRecording[];
    isLoadWithSRS: boolean = false;
    isLoadWithoutSRS: boolean = false;
    isShowSetupAccoutBtn: boolean = false;
    warningMsg: string = "";
    isSRSManager: boolean = false;
    isSRS: boolean = false;
    isSlurrpyForLiveConnect: boolean = false;
    isShowButtons: boolean = true;
    liveConnectt: LiveConnectt = <LiveConnectt>{};
    @Input() lcCheckedInRequestObj: LCCheckedInRequest = <LCCheckedInRequest>{};
    myHomeUrl: string = "";
    emailBox: EmailBox = {
        emailBoxID: 0,
        clpCompanyID: 0,
        clpUserID: 0,
        inboxAddress: '',
        appPassword: '',
        imapServer: 'imap.gmail.com',
        imapPort: 993,
        isAddLiveConnectCard: false,
        searchMethod: 0,
        isAutoAIPopulate: false,
        customSearchID: 0,
        processor: 0,
        isMoveToHandledFolder: false,
        handledFolderName: '_EngageProcessed',
        toProcessFolderName: '_EngageReProcess',
        isMarkUnhandledAsRead: false,
        ageMinutesToProcess: 0,
        status: 0,
        dtLastRun: '',
    };

    ddcustomsearch: CustomSearchResponse[] = [];
    customsearch: CustomSearchResponse = <CustomSearchResponse>{};
    searchContactCount: string = "";
    ebConnectText: string = "Connect";
    ebShowDetails: boolean = false;
    ebShowConnectDetails: boolean = true;
    ebShowPasswords: boolean = true;
    savedQuery_Filter: keyValue[] = [];
    selectedSearch: string = '';
    showSavedSearch: boolean = false;

    constructor(private fb: FormBuilder,
        private _router: Router,
        private _globalService: GlobalService,
        private _accountSetupService: AccountSetupService,
        private _localService: LocalService,
        private _appConfigService1: AppconfigService,
        private _searchContactService: SearchContactService,
        private _reportService: ReportService,
        private notifyService: NotificationService,
        private _utilityService: UtilityService, private _liveConnectSrvc: LiveConnectService) {
        
    }

    ngOnInit() {
        this.liveSettingForm = this.prepareLiveSettingForm();
        this._localService.getDefaultHome(this.encryptedUser)
            .then(async (result: AppConfig) => {
                if (result) {
                    this.myHomeUrl = result.homeURL;
                }
            });
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                if (this.user) {
                    this.setUp();
                }
                else {
                    window.location.href = this.myHomeUrl;
                }
            }
            else {
                window.location.href = this.myHomeUrl;
            }
        })
    }

    async setUp() {
        this.isShowViewMode = true;
        this.isLoadWithoutSRS = false;
        this.isLoadWithSRS = false;
        await this.liveConnect_isLiveConnectSRSAccount();
        this.isSlurrpyForLiveConnect = (this.user?.slurpyUserId > 0 || this.isSRSManager) ? true : false;
        if (this.user?.permissions == eUserPermissions.Active) {
            if (!isNullOrEmptyString(this.user?.txtMsgLongCode)) {
                await this.liveConnect_LoadByUser();

                if (!isNullOrUndefined(this.liveConnectt) && this.liveConnectt?.liveConnectID > 0) {
                    this.liveConnectId = this.liveConnectt.liveConnectID;
                    if (this.liveConnectt?.isActive) {
                        this.isShowSettings = true;
                        await this.liveConnectSettingView();
                        this.isLoadWithoutSRS = true;
                    }
                    if (this.liveConnectt?.isSRSActive) {
                        if (this.liveConnectt?.srsCLPCompanyID > -1) {
                            if (this.isSlurrpyForLiveConnect) {
                                this.isLoadWithSRS = true;
                            }
                        }
                    }
                }
                await this.getddCustomSearchList();
                await this.emailBox_LoadByCLPUser();

            } else {
                this.warningMsg = "User does not have a Long Code Number.";
                this.isShowButtons = false;
            }
        } else {
            this.warningMsg = "User does not look Active.";
            this.isShowButtons = false;
        }
    }

    async liveConnect_isLiveConnectSRSAccount() {
        await this._liveConnectSrvc.liveConnect_isLiveConnectSRSAccount(this.encryptedUser, this.user?.cLPCompanyID)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.isSRS = result?.messageBool;
                    this.isSRSManager = (result?.messageBool && this.user.userRole > eUserRole.Manager) ? true : false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.liveConnect_isLiveConnectSRSAccount", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID + 'cLPUserID ' + this.user.cLPUserID + 'slurpyUserId ' + this.user?.slurpyUserId);
                 this._utilityService.handleErrorResponse(err);
            });
    }

    prepareLiveSettingForm() {
        return this.fb.group({
            liveConnectName: new FormControl(''),
            speakName: new FormControl(''),
            announceScript: new FormControl(''),
            announceVRID: new FormControl(''),
            topNotes: new FormControl(''),
            isAlertsTab: new FormControl(false),
            isIBSMSSendUserAlertText: new FormControl(false),
            isActive: new FormControl(false),
            isSRSActive: new FormControl(false),
            srsCLPCompanyID: new FormControl(0),
            isVirtualVoicemail: new FormControl(false),
            isSlidecastAlert: new FormControl(false),
            isAutomationAlert: new FormControl(false),
            isAppointment: new FormControl(false),
            isInboundEmail: new FormControl(false),
            isAgreementAlert: new FormControl(false),
            searchedCompanyName: new FormControl('Not Found'),

            inboxAddress: new FormControl(''),
            appPassword: new FormControl(''),
            imapServer: new FormControl(''),
            imapPort: new FormControl(0),
            status: new FormControl(0),
            searchMethod: new FormControl(0),
            customSearchID: new FormControl(0),
            handledFolderName: new FormControl(''),
            toProcessFolderName: new FormControl(''),
            isMarkUnhandledAsRead: new FormControl(''),
        });
    }

    liveConnectSettingcbStatus() {
        this._liveConnectSrvc.liveConnectSettingcbStatus(this.encryptedUser, this.user?.cLPUserID, this.liveConnectId, this.liveSettingForm.controls.isActive.value)
            .then((result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    if (this.liveConnectId == 0) {
                        this.liveConnectId = result?.messageInt;
                        this.liveSettingForm.get("isActive").setValue(false);
                    } else {
                        this.lcCheckedInRequestObj.liveConnectID = result?.messageInt;
                        this.liveConnect_LoadByUser();
                        this.setUp();
                    }
                    //if (!this.isFromLiveConnect) {
                    //}
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.liveConnectSettingcbStatus", err.message, null, 'cLPUserID ' + this.user?.cLPUserID + 'liveConnectId ' + this.liveConnectId + 'isStatus ' + this.liveSettingForm.controls.isActive.value);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async liveConnect_LoadByUser() {
        await this._liveConnectSrvc.liveConnect_LoadByUser(this.encryptedUser, this.user?.cLPUserID)
            .then(async (result: LiveConnectt) => {
                if (!isNullOrUndefined(result)) {
                    this.liveConnectt = result;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.liveConnect_LoadByUser", err.message, null, 'cLPUserID ' + this.user.cLPUserID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async emailBox_LoadByCLPUser() {
        this.ebShowDetails = false;
        await this._liveConnectSrvc.emailBox_LoadByCLPUser(this.encryptedUser, this.user?.cLPUserID)
            .then(async (result: EmailBoxResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.emailBox = result.emailBox;

                    if (this.emailBox.emailBoxID > 0) {
                        this.liveSettingForm.get("inboxAddress").setValue(this.emailBox.inboxAddress);
                        this.liveSettingForm.get("appPassword").setValue(this.emailBox.appPassword);
                        this.liveSettingForm.get("imapServer").setValue(this.emailBox.imapServer);
                        this.liveSettingForm.get("imapPort").setValue(this.emailBox.imapPort);

                        if (this.emailBox.status == eEmailBoxStatus.Active) {
                            this.ebConnectText = "Disconnect";
                            this.ebShowDetails = true;
                            this.ebShowConnectDetails = false;
                            this.ebShowPasswords = false;
                        }
                        else {
                            this.ebConnectText = "Connect";
                            this.ebShowDetails = false;
                            this.ebShowConnectDetails = true;
                            this.ebShowPasswords = true;
                        }

                        this.liveSettingForm.get("searchMethod").setValue(this.emailBox.searchMethod);

                        if (this.emailBox.searchMethod == 4)
                            this.showSavedSearch = true;

                        if (this.emailBox.customSearchID > 0) {
                            let search = this.ddcustomsearch.filter(x => x.customSearchID == this.emailBox.customSearchID)[0];

                            if (!isNullOrUndefined(search)) {
                                this.selectedSearch = search.displayName;
                                this.liveSettingForm.get("customSearchID").setValue(this.emailBox.customSearchID);
                            }
                        }
                        else {
                            this.selectedSearch = '';
                        }

                        this.liveSettingForm.get("handledFolderName").setValue(this.emailBox.handledFolderName);
                        this.liveSettingForm.get("toProcessFolderName").setValue(this.emailBox.toProcessFolderName);
                        this.liveSettingForm.get("isMarkUnhandledAsRead").setValue(this.emailBox.isMarkUnhandledAsRead);
                    }
                    else {
                        this.emailBox.inboxAddress = this.user?.email;
                        this.emailBox.imapServer = "imap.gmail.com";
                        this.emailBox.imapPort = 993;
                        this.emailBox.status = 0;
                        this.ebShowConnectDetails = true;
                        this.ebShowPasswords = true;

                        this.liveSettingForm.get("inboxAddress").setValue(this.user?.email);
                        this.liveSettingForm.get("appPassword").setValue("");
                        this.liveSettingForm.get("imapServer").setValue("imap.gmail.com");
                        this.liveSettingForm.get("imapPort").setValue("993");

                        this.ebConnectText = "Connect";
                        this.ebShowDetails = false;

                        this.liveSettingForm.get("searchMethod").setValue(0);
                        this.showSavedSearch = false;

                        this.liveSettingForm.get("customSearchID").setValue(0);
                        this.selectedSearch = '';

                        this.liveSettingForm.get("handledFolderName").setValue("");
                        this.liveSettingForm.get("toProcessFolderName").setValue("");
                        this.liveSettingForm.get("isMarkUnhandledAsRead").setValue(false);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.emailBox_LoadByCLPUser", err.message, null, 'cLPUserID ' + this.user.cLPUserID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    showViewMode() {
        this.isShowViewMode = !this.isShowViewMode;
    }

    liveConnectSave() {
        this.liveConnectt.liveConnectName = this.liveSettingForm.controls.liveConnectName.value;
        this.liveConnectt.speakName = this.liveSettingForm.controls.speakName.value;
        this.liveConnectt.announceScript = this.liveSettingForm.controls.announceScript.value;
        this.liveConnectt.topNotes = this.liveSettingForm.controls.topNotes.value;
        this.liveConnectt.announceVRID = this.liveSettingForm.controls.announceVRID.value == "" ? 0 : this.liveSettingForm.controls.announceVRID.value;
        this.liveConnectt.srsCLPCompanyID = this.liveSettingForm.controls.srsCLPCompanyID.value;
        this.liveConnectt.isAlertsTab = this.liveSettingForm.controls.isAlertsTab.value;
        this.liveConnectt.isIBSMSSendUserAlertText = this.liveSettingForm.controls.isIBSMSSendUserAlertText.value;
        this.liveConnectt.alertItems = "";
        if (this.liveSettingForm.controls.isVirtualVoicemail.value)
            this.liveConnectt.alertItems += "5" + ',';
        if (this.liveSettingForm.controls.isSlidecastAlert.value)
            this.liveConnectt.alertItems += "8" + ',';
        if (this.liveSettingForm.controls.isAutomationAlert.value)
            this.liveConnectt.alertItems += "9" + ',';
        if (this.liveSettingForm.controls.isAppointment.value)
            this.liveConnectt.alertItems += "4" + ',';
        if (this.liveSettingForm.controls.isInboundEmail.value)
            this.liveConnectt.alertItems += "11" + ',';
        if (this.liveSettingForm.controls.isAgreementAlert.value)
            this.liveConnectt.alertItems += "15";

        if (this.emailBox.emailBoxID > 0) {
            if (this.emailBox.status == eEmailBoxStatus.Active) {

                this.emailBox.searchMethod = +this.liveSettingForm.controls.searchMethod.value;
                this.emailBox.customSearchID = +this.liveSettingForm.controls.customSearchID.value;

                this.emailBox.isMoveToHandledFolder = true;
                this.emailBox.handledFolderName = this.liveSettingForm.controls.handledFolderName.value;
                this.emailBox.toProcessFolderName = this.liveSettingForm.controls.toProcessFolderName.value;
                this.emailBox.isMarkUnhandledAsRead = this.liveSettingForm.controls.isMarkUnhandledAsRead.value;
                this.emailBox.ageMinutesToProcess = 30;
            }
        }

        this._liveConnectSrvc.liveConnectSave(this.encryptedUser, this.liveConnectt)
            .then((result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    if (this.emailBox.emailBoxID > 0) {
                        this.eb_save(() => {
                            this.setUp();
                            this.notifyService.showSuccess('Settings', 'Saved successfully.', 5000);
                        })
                    }
                    else {
                        this.setUp();
                        this.notifyService.showSuccess('Settings', 'Saved successfully.', 5000);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.liveConnectSave", err.message, this.liveConnectt);
                this._utilityService.handleErrorResponse(err);
            });
    }

    liveConnectSettingisSRSActive() {
        this._liveConnectSrvc.liveConnectSettingisSRSActive(this.encryptedUser, this.user?.cLPUserID, this.liveConnectId, this.liveSettingForm.controls.isSRSActive.value)
            .then((result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.setUp();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.liveConnectSettingisSRSActive", err.message, null, 'cLPUserID ' + this.user.cLPUserID + 'liveConnectId ' + this.liveConnectId + 'isSRSActive ' + this.liveSettingForm.controls.isSRSActive.value);
                this._utilityService.handleErrorResponse(err);
            });
    }

    liveConnectSettingSRSSave() {
        this._liveConnectSrvc.liveConnectSettingSRSSave(this.encryptedUser, this.user?.cLPUserID, this.liveConnectId, this.liveSettingForm.controls.srsCLPCompanyID.value)
            .then((result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.setUp();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.liveConnect_isLiveConnectSRSAccount", err.message, null, 'cLPUserID ' + this.user.cLPUserID + 'liveConnectId ' + this.liveConnectId + 'srsCLPCompanyID ' + this.liveSettingForm.controls.srsCLPCompanyID.value );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async liveConnectSettingView() {
        if (!this.isFromLiveConnect) {
            this.lcCheckedInRequestObj.clpCompanyID = this.user?.cLPCompanyID;
            this.lcCheckedInRequestObj.clpUserID = this.user?.cLPUserID;
            this.lcCheckedInRequestObj.isSlurpy = this.isSlurrpyForLiveConnect;
            this.lcCheckedInRequestObj.isSRS = this.isSRS
            this.lcCheckedInRequestObj.liveConnectID = this.liveConnectId > 0 ? this.liveConnectId : 0;
        }
        await this._liveConnectSrvc.liveConnectSettingView(this.encryptedUser, this.lcCheckedInRequestObj)
            .then(async (result: LiveConnectSettingResponse) => {
                if (!isNullOrUndefined(result)) {
                    const response = UtilityService.clone(result);
                    this.officeCodes = response?.officeCodes;
                    this.teamCodes = response?.teamCodes;
                    this.officeCodesSRS = response?.officeCodesSRS;
                    this.teamCodesSRS = response?.teamCodesSRS;
                    this.voiceRecordDD = response?.voiceRecordDD;
                    /* this.liveConnectt = response?.LiveConnectResponse;*/
                    this.patchLiveSettingFormValue();
                    var alertItem: string[] = [];
                    alertItem = this.liveConnectt?.alertItems?.split(",");
                    alertItem?.forEach(x => {
                        if (!isNullOrEmptyString(x)) {
                            switch (x) {
                                case "5":
                                    this.liveSettingForm.get("isVirtualVoicemail").setValue(true);
                                    break;
                                case "7":
                                /*   this.liveSettingForm.get("isVirtualVoicemail").setValue(true);*/
                                case "8":
                                    this.liveSettingForm.get("isSlidecastAlert").setValue(true);
                                    break;
                                case "9":
                                    this.liveSettingForm.get("isAutomationAlert").setValue(true);
                                    break;
                                case "4":
                                    this.liveSettingForm.get("isAppointment").setValue(true);
                                    break;
                                case "11":
                                    this.liveSettingForm.get("isInboundEmail").setValue(true);
                                    break;
                                case "15":
                                    this.liveSettingForm.get("isAgreementAlert").setValue(true);
                                    break;
                            }
                        }
                    })
                    if (this.liveConnectt?.isSRSActive) {
                        if (this.liveConnectt?.srsCLPCompanyID > -1) {
                            this.onLoadSrsCompanyId();
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.liveConnectSettingView", err.message, this.lcCheckedInRequestObj);
                this._utilityService.handleErrorResponse(err);
            });
    }

    patchLiveSettingFormValue() {
        const liveConnectResponse = this.liveConnectt;
        for (let key in liveConnectResponse) {
            let value = liveConnectResponse[key];
            this.preparePatchFormControlValue(key, value);
        }
    }

    preparePatchFormControlValue(key, value) {
        if (this.liveSettingForm.get(key)) {
            this.liveSettingForm.get(key).setValue(value);
        }
    }

    async getCompanyData(clpCompanyId: number) {
        await this._accountSetupService.getClpCompany(this.encryptedUser, clpCompanyId)
            .then(async (result: CompanyResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    if (!isNullOrEmptyString(response?.company?.companyName))
                        this.liveSettingForm.get("searchedCompanyName").setValue(response?.company?.companyName);
                    else
                        this.liveSettingForm.get("searchedCompanyName").setValue("Not Found");
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.getCompanyData", err.message, null, 'cLPCompanyID ' + clpCompanyId);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async onLoadSrsCompanyId() {
        if (!isNullOrEmptyString(this.liveSettingForm.controls.srsCLPCompanyID.value)) {
            await this.getCompanyData(this.liveSettingForm.controls.srsCLPCompanyID.value);
            if (this.liveSettingForm.controls.searchedCompanyName.value != "Not Found")
                this.isShowSetupAccoutBtn = true;
            else
                this.isShowSetupAccoutBtn = false;
        }
    }

    getGreetingRecordingName(id: number) {
        return this.voiceRecordDD?.find(x => x.voiceRecordingID == id)?.shortDesc;
    }

    checkActiveStatus(value: boolean) {
        if (value) {
            return 'Activated for Long Code: ' + (isNullOrUndefined(this.user?.txtMsgLongCode) ? "" : this.user?.txtMsgLongCode) + (isNullOrUndefined(this.user?.TxtMsgTollFree) ? "" : this.user?.TxtMsgTollFree);
        }
        else {
            return 'Not-Activated';
        }

    }

    pixString(val: string): string {
        let value: string = "";
        if (!isNullOrUndefined(val)) {
            value = val.replace(/[^a-zA-Z0-9]/g, '');
        }
        return value;
    }

    async getddCustomSearchList() {
        await this._searchContactService.customSearchs_GetList(this.encryptedUser, this.user?.cLPUserID, this.user?.cLPCompanyID, 2, true)
            .then(async (result: CustomSearchResponse[]) => {
                if (result) {
                    if (result.length > 0) {
                        this.ddcustomsearch = UtilityService.clone(result);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    ebConnect() {
        if (this.ebConnectText == 'Connect') {
            if (this.emailBox.emailBoxID <= 0) {
                this.emailBox.clpCompanyID = this.user?.cLPCompanyID;
                this.emailBox.clpUserID = this.user?.cLPUserID;
                this.emailBox.inboxAddress = this.liveSettingForm.controls.inboxAddress.value;
                this.emailBox.appPassword = this.liveSettingForm.controls.appPassword.value;
                this.emailBox.status = eEmailBoxStatus.Disabled;
                this.emailBox.imapServer = this.liveSettingForm.controls.imapServer.value;
                this.emailBox.imapPort = this.liveSettingForm.controls.imapPort.value;
                this.emailBox.processor = eEmailBoxProcessor.Gmail;
                this.emailBox.isAddLiveConnectCard = true;
                this.emailBox.isMoveToHandledFolder = true;
                this.emailBox.handledFolderName = '_EngageProcessed';
                this.emailBox.toProcessFolderName = '_EngageReProcess';
                this.emailBox.isMarkUnhandledAsRead = false;

                this.eb_create(() => {
                    if (this.emailBox.emailBoxID > 0) {
                        this.eb_connect(() => {
                            this.setUp();
                            this.notifyService.showSuccess('Email Box', 'Connection succeeded.', 5000);
                        })
                    }
                });
            }
            else {
                this.emailBox.status = eEmailBoxStatus.Disabled;
                this.emailBox.inboxAddress = this.liveSettingForm.controls.inboxAddress.value;
                this.emailBox.appPassword = this.liveSettingForm.controls.appPassword.value;
                this.emailBox.imapServer = this.liveSettingForm.controls.imapServer.value;
                this.emailBox.imapPort = this.liveSettingForm.controls.imapPort.value;

                this.eb_save(() => {
                    this.eb_connect(() => {
                        this.setUp();
                        this.notifyService.showSuccess('Email Box', 'Connection succeeded.', 5000);
                    })
                });
            }
        }
        else {
            this.emailBox.status = eEmailBoxStatus.Disabled;
            this.emailBox.appPassword = '';
            this.liveSettingForm.get("appPassword").setValue("");

            this.eb_save(() => {
                this.setUp();
                this.isShowViewMode = false;
            });
        }
    }

    eb_connect(callback) {
        this._liveConnectSrvc.emailBox_Connect(this.encryptedUser, this.emailBox)
            .then((result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    if (result.messageString == '') {
                        this.emailBox.status = eEmailBoxStatus.Active;
                        this.eb_save(() => {
                            if (callback) {
                                callback();
                            }
                        });
                    }
                    else {
                        this.notifyService.showError('Email Box', result.messageString, 8000);
                        this.liveSettingForm.get("appPassword").setValue("");
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.eb_connect.emailBox_Connect", err.message, this.emailBox);
                this._utilityService.handleErrorResponse(err);
            });
    }

    eb_save(callback) {
        this._liveConnectSrvc.emailBox_Save(this.encryptedUser, this.emailBox)
            .then((result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    if (callback) {
                        callback();
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.eb_save.emailBox_Save", err.message, this.emailBox);
                this._utilityService.handleErrorResponse(err);
            });
    }

    eb_create(callback) {
        this._liveConnectSrvc.emailBox_Create(this.encryptedUser, this.emailBox)
            .then((result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.emailBox.emailBoxID = result.messageInt;
                    if (callback) {
                        callback();
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.eb_create.emailBox_Create", err.message, this.emailBox);
                this._utilityService.handleErrorResponse(err);
            });
    }

    getSearchMethod(value) {
        let text = '';
        switch (value) {
            case 0: text = 'Entire Account'; break;
            case 1: text = 'My Contacts Only'; break;
            case 2: text = 'My Team Only'; break;
            case 3: text = 'My Office Only'; break;
            case 4: text = 'Saved Search'; break;
        }

        return text;
    }

    drpSearchMethod_changed() {
        if (+this.liveSettingForm.controls.searchMethod.value == 4) {
            this.showSavedSearch = true;
        }
        else {
            this.showSavedSearch = false;
        }
    }
}
